import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from '../Tooltip/Tooltip';
import IconButton from '../IconButton/IconButton';
import {
  ParticipantName,
  Educator,
  StyledListItem,
  StudentAdded,
  StyledAvatar,
  ParticipantContainer,
  ParticipantLeftInfo,
  ParticipantEmail,
} from './ParticipantContent.styled';

const ParticipantContent = ({
  avatar,
  fullName,
  isInstructor,
  isDisabled,
  icon: Icon,
  onClick,
  tooltip,
  isReadOnly,
  userInfoGreyedOut,
  email,
}) => {
  let button = !isReadOnly && Icon && (
    <IconButton
      icon={Icon}
      onClick={onClick}
      label="action-group"
      size="small"
    />
  );

  if (button && tooltip) {
    button = (
      <Tooltip title={tooltip} position="top">
        <div>{button}</div>
      </Tooltip>
    );
  }

  const userInfo = (
    <ParticipantContainer>
      <StyledAvatar
        size="medium"
        name={fullName}
        src={avatar}
        userInfoGreyedOut={userInfoGreyedOut || isDisabled}
      />
      <ParticipantLeftInfo>
        <ParticipantName userInfoGreyedOut={userInfoGreyedOut || isDisabled}>
          <span>{fullName}</span>
          <span>{isInstructor ? ' - ' : ''} </span>
          {isInstructor && <Educator>Educator</Educator>}
          {userInfoGreyedOut && !isDisabled ? ' - ' : ''}
          {userInfoGreyedOut && !isDisabled && (
            <StudentAdded>Added</StudentAdded>
          )}
        </ParticipantName>
        <ParticipantEmail>{email}</ParticipantEmail>
      </ParticipantLeftInfo>
    </ParticipantContainer>
  );

  return <StyledListItem leftDecoration={userInfo} rightDecoration={button} />;
};

ParticipantContent.propTypes = {
  fullName: PropTypes.string,
  avatar: PropTypes.string,
  email: PropTypes.string,
  isInstructor: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  isDisabled: PropTypes.bool,
  userInfoGreyedOut: PropTypes.bool,
  icon: PropTypes.elementType,
  tooltip: PropTypes.string,
  onClick: PropTypes.func,
};

ParticipantContent.defaultProps = {
  avatar: null,
  fullName: '',
  email: '',
  isInstructor: false,
  onClick: undefined,
  icon: null,
  tooltip: null,
  isReadOnly: false,
  isDisabled: false,
  userInfoGreyedOut: false,
};

export default React.memo(ParticipantContent);
